<template>
    <div>
        <HeaderBg :title="$t('questions.addTitle')" />

        <div class="form_container">
            <form @submit.prevent="addQuestion">
                <div class="input_container">
                    <label>{{$t('questions.question')}}</label>
                    <input type="text" v-model="questions[0].question">
                </div>
                <div class="input_container">
                    <label>{{$t('questions.answer')}}</label>
                    <client-only>
                        <VueEditor  v-model="questions[0].answer" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('questions.answerInEnglish')}}</label>
                    <select v-model="questions[0].locale">
                        <option value="ar">{{$t('questions.arabic')}}</option>
                        <option value="en">{{$t('questions.english')}}</option>
                    </select>
                </div>
                <!-- <div class="add_new_question saveBtn" @click="addNewQuestion">
                    أضف سوْال
                </div> -->
                <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck == true">
                    <p v-for="(error, index) in errors" :key="index"> {{error}} </p>
                </div>
                <button class="saveBtn" v-if="postLoaded == false">
                    {{this.$route.params.id !== undefined ? $t('questions.edit') : $t('questions.save') }}
                </button>
                <button class="saveBtn" v-if="postLoaded == true"><b-spinner></b-spinner></button>
            </form>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Request from '../../../services/Request';
import { VueEditor } from "vue2-editor";

export default {
    name :'AddQuestions',
    components: {HeaderBg, VueEditor},
    data(){
        return{
            postLoaded: false,
            questions: [
                {
                    question : "",
                    answer : "",
                    locale : ""
                },
            ],
            errors: [],
            ErrorCheck: false,
        }
    },
    mounted(){
        this.getQuestion();
    },
    methods:{
        // addNewQuestion(){
        //     this.questions.push(
        //         {
        //             question : "",
        //             answer : "",
        //             locale : ""
        //         },
        //     )
        // },

        addQuestion(){
            this.postLoaded = true;

            if(this.$route.params.id !== undefined){
                axios.put(`https://app.almujtama.com.sa/admin/investor_relation_questions/${this.$route.params.id}`, {
                    question: this.questions[0].question,
                    answer: this.questions[0].answer,
                    locale: this.questions[0].locale
                }, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                })
                .then( () => {
                    this.$router.push('/admin/questions')
                    this.postLoaded = false
                })  
                .catch(err =>  {
                    this.errors = err.response.data.errors;
                    this.ErrorCheck = true;
                    this.postLoaded = false;
                    
                })
            } else {
                axios.post('https://app.almujtama.com.sa/admin/investor_relation_questions', {questions:this.questions}, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                })
                .then( () => {
                    this.$router.push('/admin/questions')
                    this.postLoaded = false
                })  
                .catch(err =>  {
                    this.errors = err.response.data.errors;
                    this.ErrorCheck = true;
                    this.postLoaded = false;
                })
            }
        },
        getQuestion(){
            if(this.$route.params.id !== undefined){
                Request.fetch(`admin/investor_relation_questions/${this.$route.params.id}`)
                .then(response => {
                    console.log(response)
                    this.questions[0].question = response.data.data.question
                    this.questions[0].answer = response.data.data.answer
                    this.questions[0].locale = response.data.data.locale
                })
                .catch(err => {
                    if(Request.statusIsFaield(err)){
                        this.$router.push('/login')
                        localStorage.removeItem('token')
                    }
                });
            }
        }
    }
}
</script>
<style lang="scss" scoped>

.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            margin-bottom: 40px;
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input,
            select{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 50%;
            }
        }
        button{
            margin: 30px auto 0 auto;   
        }
    }
}
.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-left: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
</style>